import { Link } from 'react-router-dom'
import {ShieldOff, ArrowLeft, Search} from 'lucide-react'
import Layout from '@/components/Layout'

const C = {
  bgDeep: '#000000',
  surface: '#070a0c',
  turq: '#1ad6c4',
  turqDim: 'rgba(26,214,196,0.12)',
  borderTurq: 'rgba(26,214,196,0.30)',
  border: 'rgba(255,255,255,0.08)',
  textSecond: '#b4c0cc',
  textMuted: '#6a7682',
}

export default function NotFound() {
  return (
    <Layout>
      <section
        className="min-h-[80vh] flex items-center justify-center"
        style={{ background: C.bgDeep }}
      >
        <div className="max-w-[520px] mx-auto px-5 py-20 text-center flex flex-col items-center">
          {/* Icon */}
          <div
            className="w-20 h-20 rounded-2xl flex items-center justify-center mb-8"
            style={{ background: C.turqDim, border: `1px solid ${C.borderTurq}` }}
          >
            <ShieldOff className="w-9 h-9" style={{ color: C.turq }} />
          </div>

          {/* Code */}
          <p
            className="text-7xl font-light mb-4 leading-none"
            style={{ color: C.turq, letterSpacing: '-3px' }}
          >
            404
          </p>

          <h1 className="text-2xl font-semibold text-white mb-3 leading-snug">
            Page not found
          </h1>
          <p className="text-sm leading-relaxed mb-10" style={{ color: C.textMuted }}>
            The page you're looking for doesn't exist or has been moved. Try browsing the audit registry or head back home.
          </p>

          {/* Actions */}
          <div className="flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-semibold transition-all hover:brightness-110 active:scale-95"
              style={{ background: C.turq, color: '#000000' }}
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Home
            </Link>
            <Link
              to="/projects"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm transition-all hover:bg-white/5"
              style={{ color: C.textSecond, border: `1px solid rgba(255,255,255,0.12)` }}
            >
              <Search className="w-4 h-4" />
              Browse Registry
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  )
}
